export enum EventTypes {
  Curbside = 'curbside',
  InOffice = 'in-office',
  Reminder = 'reminder',
}
